import { grey } from "@mui/material/colors";

const GREY_300 = grey[300];
const GREY_700 = grey[700];
const GREY_900 = grey[900];

export { GREY_300, GREY_700, GREY_900 };
